import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MainService } from '../../mainservices/mainservices.model';
import { SubServices } from '../subservices.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Observable } from 'rxjs';
import { SubservicesService } from '../subservices.service';
import { MainserviceService } from '../../mainservices/mainservice.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';
import { Globle } from 'src/assets/globle';

@Component({
  selector: 'app-subservicelist',
  templateUrl: './subservicelist.component.html',
  styleUrls: ['./subservicelist.component.css'],
  queries: {
    contentRef: new ViewChild("Modal"),
  }
})
export class SubservicelistComponent implements OnInit {

  //#region variables
  mainServicesList: MainService[] = [];
  subServicesList: SubServices[] = [];
  displayedColumns: string[] = ['id', 'arabicName', 'englishName', 'imgUrl', "edit", "delete"];
  dataSource!: MatTableDataSource<SubServices>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false;
  public contentRef!: TemplateRef<any>;
  subService: SubServices = {} as SubServices;
  subServicestatus: { id: boolean, name: string }[] = [];
  selectedStatus: boolean = true;
  selectedMainService: any
  language!: number;
  imagPath: any;
  pageSize = 100;
  //#endregion

  constructor(private service: SubservicesService,
    private mainServiceService: MainserviceService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private localStorage: LocalStorageService,
    private translate: TranslateService,
    private globle: Globle,
    private storage: SessionStorageService) { }

  ngOnInit() {
    this.subServicestatus = [{ id: true, name: this.translate.instant("active") },
    { id: false, name: this.translate.instant("notActive") }];
    this.selectedStatus = true;
    this.language = this.localStorage.retrieve("lang");
    this.imagPath = this.globle.imgPath;
    this.pageSize = this.globle.pageSize;
    this.getMainService();
    let category = this.storage.retrieve("MainServiceSearch");
    if (category != null && category != undefined) {
      this.selectedMainService = category
      this.selectMainserviceChange();
    }
  }

  getMainService() {
    this.spinnerOverlay = true;
    this.mainServiceService.getAll(true).subscribe(data => {
      this.mainServicesList = data
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  getSubServices() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedMainService, this.selectedStatus).subscribe(data => {
      this.subServicesList = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.subServicesList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  createNew() {
    this.router.navigate(['./master/services/subserviceform']);
  }

  edit(id: number) {
    this.router.navigate(['./master/services/subserviceform/' + id]);
  }

  onDelete(id: number) {
    this.subService.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.Delete(this.subService.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getSubServices();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectStatusChange() {
    this.getSubServices();
  }

  selectMainserviceChange() {
    this.storage.store("MainServiceSearch", this.selectedMainService);
    this.getSubServices();
  }


}
